import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isJobsLoaded: false,
  isCompanyLoaded: false,
  message: {
    text: '',
    severity: '',
    unixTime: new Date().getTime()
  }
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    loadingRequested(state) {
      state.isLoading = true;
    },
    loadingSucceeded(state) {
      state.isLoading = false;
    },
    loadingFailed(state) {
      state.isLoading = false;
    },
    loadingUserJobsRequested(state) {
      state.isJobsLoaded = false;
    },
    loadingUserJobsDone(state) {
      state.isJobsLoaded = true;
    },
    loadingUserJobsFailed(state) {
      console.error('loadingUserJobsFailed');
      state.isJobsLoaded = false;
    },
    loadingUserCompanyRequested(state) {
      state.isCompanyLoaded = false;
    },
    loadingUserCompanyFailed(state) {
      state.isCompanyLoaded = false;
    },
    getJobsByCurrentUserSucceeded(state) {
      state.isJobsLoaded = true;
    },
    loadingUserCompanyDone(state) {
      state.isCompanyLoaded = true;
    },
    messageUpdated(state, action) {
      state.message = {
        text: action.payload.text,
        severity: action.payload.severity,
        unixTime: new Date().getTime()
      };
    }
  }
});

export const messageSelector = (state) => state.app.message;
export const isLoadingSelector = (state) => state.app.isLoading;
export const isJobsLoadedSelector = (state) => state.app.isJobsLoaded;
export const isCompanyLoadedSelector = (state) => state.app.isCompanyLoaded;
export const isLoadingCompleteSelector = (state) =>
  isJobsLoadedSelector(state) && isCompanyLoadedSelector(state);

export const {
  loadingRequested,
  loadingSucceeded,
  loadingFailed,
  getJobsByCurrentUserSucceeded,
  loadingUserCompanyDone,
  messageUpdated,
  loadingUserJobsRequested,
  loadingUserJobsDone,
  loadingUserJobsFailed,
  loadingUserCompanyRequested,
  loadingUserCompanyFailed
} = appSlice.actions;

export default appSlice.reducer;
